import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from '@markant-platform/shared/data-access';
import {
  ExportOrganizationRequestDto,
  ExportOrganizationResponseDto,
  ExportUserRequestDto,
  ExportUserResponseDto,
} from '@markant-platform/report/model';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  constructor(private readonly http: HttpClient) {}

  private readonly url: string = AppConfigService.appConfiguration.apiUrl['reportService'];

  getReportJobForUserExport(
    exportUserRequestDto: ExportUserRequestDto,
    platformLocale: string
  ): Observable<ExportUserResponseDto> {
    const headers = new HttpHeaders().set('platform-locale', platformLocale);

    return this.http.post<ExportUserResponseDto>(`${this.url}/users`, exportUserRequestDto, {
      headers: headers,
    });
  }

  getReportJobForOrganizationExport(
    exportOrganizationRequestDto: ExportOrganizationRequestDto,
    platformLocale: string
  ): Observable<ExportOrganizationResponseDto> {
    const headers = new HttpHeaders().set('platform-locale', platformLocale);

    return this.http.post<ExportOrganizationResponseDto>(`${this.url}/organizations`, exportOrganizationRequestDto, {
      headers: headers,
    });
  }

  getFinishedReport(orderId: string): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.url}/order/${orderId}`, {
      responseType: 'blob',
      observe: 'response',
    });
  }
}
